import React from 'react'
import {Footer } from '../components'
import Projects from '../components/Projects'
import Meta from '../components/common/Meta'

function ProjectsPage() {
  return (
    <div>
      <Meta
        title="Our Projects | Construction & Design Portfolio"
        description="Explore completed and ongoing construction, architectural, engineering, and sustainable building projects delivered across Rwanda."
        keywords="
          Design and build Rwanda, Turnkey building solutions,
          Turnkey building solutions Africa,
          Construction project management Rwanda,
          Project supervision Kigali,
          Building project planning,
          Construction management services,
          Construction quality control Rwanda,
          Safety & quality control, Safety management Kigali,
          Gestion de projets de construction,
          Métré et estimation des coûts,
          Contrôle qualité chantier,
          Gukurikirana imishinga yo kubaka,
          Kugenzura ingengo y’imari,
          Kugenzura ubuziranenge bw’akazi,
          Building, Structure audit"
    />
      <nav className=' bg-contact-page justify-center pt-10 min-h-[250px] bg-cover' >
        <h1 className='font-bold text-5xl text-white uppercase text-center'>About us</h1>
        <p className='text-xl text-center text-gray-400 mt-4'>We would love to tell you more about ourselves</p>
      </nav>
      <Projects/>
      <Footer />
    </div>
  )
}

export default ProjectsPage
